// extracted by mini-css-extract-plugin
export default {"container":"gradient_container__4Gk8n"};